export default "__VITE_ASSET__YABw3XEk__"